// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.border[data-v-1cfda13e] {\n  margin-top: 10px;\n  border: 1px solid #E1E4EB;\n  padding: 10px 18px 18px;\n}\n", ""]);
// Exports
module.exports = exports;
